import {Application} from "@hotwired/stimulus"
import $ from 'jquery';
window.$ = window.jQuery = $;
import {Calendar} from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de';

const application = Application.start()

import CalendarController from "./controllers/calendar_controller"
// import CalendarModalController from "./controllers/modal-form_controller"

application.register("calendar", CalendarController)
//application.register("calendarModal", CalendarModalController)